import React from 'react'
import Chat from "../components/Chat"
import Sidebar from "../components/Sidebar"
import Welcome from "../components/Welcome"
import './Home.css'

function Home({type}) {
  const jsx = type === "chat" ? 
    <div className="home__container">
      <Sidebar />
      <Chat />
    </div>
        :
    <div className="home__container">
      <Sidebar />
      <Welcome />
    </div>;

  return (
    <div className="home">
        {jsx}
    </div>
  )
}

export default Home
